import { baseUrl } from "../api";

export const enrollmentsUrl = `${baseUrl}enrollments/`;
